/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import { fabric } from "fabric";
import { calculateScaleFactor } from '@/utils/common'

// @NOTE: Used to add unsplash image

/**
 * @param {Object} file
 */
export default async function image (obj, options) {
  return await new Promise((resolve) => {
    fabric.Image.fromURL(
      obj.src,
      function (img) {
        img.type = "image";

        if (!obj.version) {
          const scaleFactor = calculateScaleFactor(options.maxWidth, options.maxHeight, img.width, img.height);

          obj.scaleX = scaleFactor;
          obj.scaleY = scaleFactor;

          obj.resolution = `${img.width}x${img.height}`;
        }

        img.set(obj);

        resolve(img);
      },
      {
        crossOrigin: "anonymous",
      }
    );
  });

  // Set the object properties
  // @TODO: remove this from here, move to composable
  // if (!obj.version) {
  //   const scaleFactor = calculateScaleFactor(options.maxWidth, options.maxHeight, img.width, img.height);
  //   const scale = scaleFactor / options.canvasScaleFactor;
  //   console.log("SET scale", scale)

  //   obj.scaleX = scale;
  //   obj.scaleY = scale;
  // }

  // img.set(obj);

  // img.resolution = `${img.width}x${img.height}`;

  // return img;
}
